import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=23f54f11&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=23f54f11&prod&lang=scss&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=23f54f11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f54f11",
  null
  
)

export default component.exports